import React from "react";

export default function Footer() {
  return (
    <footer className="bg-white/10 backdrop-blur-md border-t border-white/20 text-white py-6 mt-auto">
      <div className="container mx-auto text-center">
        <p className="text-sm">
          © {new Date().getFullYear()} LisaNails. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
